<template>
  <div :class="$style['product-header']">
    <h1 :class="$style['product-header__title']">
      {{ product?.title }}
    </h1>

    <h2 :class="$style['product-header__subtitle']">
      {{ product?.colorName }}
    </h2>
    <!-- Product price -->
    <div :class="$style['product-header__price']">
      <ProductPrice
        v-if="product?.price"
        large
        :price="product.price"
        :percent="product.salePercent"
        :sale="product.originalPrice" />
    </div>
    <div v-if="product?.labels" :class="$style['product-header__tags']">
      <LazyTag
        v-for="(label, index) in product.labels"
        :key="index"
        :to="label.slug"
        big
        :type="label.type">
        {{ label.title }}
      </LazyTag>
    </div>
  </div>
</template>
<script setup>
defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  product: {
    type: [Object, Function, Boolean],
    default: null
  }
})
</script>

<style lang="scss" module>
.product-header {
  &__title {
    font-size: var(--font-size-xxl);
    line-height: calc(var(--line-height) * 2);
    margin-bottom: var(--spacing);
    text-transform: none;
    text-wrap: pretty;
  }

  &__subtitle {
    color: var(--grey-dark);
    font-family: var(--font-base);
    font-size: var(--font-size-m);
    line-height: var(--line-height);
    font-weight: var(--font-weight-normal);
    text-transform: none;

    &__flex {
      display: flex;
      justify-content: space-between;
    }
  }

  &__price {
    margin-top: var(--spacing);
  }

  &__percentage {
    margin-right: calc(var(--spacing) * 0.5);
    background-color: var(--black);
    color: var(--white);
    padding: calc(var(--spacing) * 0.35) calc(var(--spacing) * 0.75);
    font-family: var(--font-heading);
    font-weight: bold;
    font-size: var(--font-size-m);
    vertical-align: middle;
    line-height: 1.5rem;
    pointer-events: none;
  }

  &__tags {
    margin-top: var(--spacing);
    display: flex;
    flex-flow: row-reverse wrap;
    justify-content: flex-end;
    gap: var(--spacing);
  }
}
</style>
